import React, { Component } from 'react';
import { GraphWrapper } from "@/components/Graph";
import { overallEffectLine } from "@/components/DataEffect/GraphConfig";
import DownloadDialog from "@/components/DataEffect/Download";
export default class RelatedIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flowQuotaData: null,
            userQuotaData: null,
        };
    }
    componentDidMount() {
        // this.setState({
        //   flowQuotaData: flowQuotaData || {},
        //   userQuotaData: userQuotaData || {},
        // });
    }
    render() {
        const { relatedIndexs, sceneCode } = this.props.dataEffectValue;
        const { flowQuotaData, userQuotaData } = relatedIndexs;
        return (<div className="">
        <div className="data-effect-title mb_20">整体情况</div>
        <div className="border">
          <p>流量指标数据</p>
          <GraphWrapper key={11} className="overall-effect-graph-wrapper" config={overallEffectLine(flowQuotaData, flowQuotaData.isRate, true)} height={350}/>
          <DownloadDialog key={1} className="traffic-bucket-content-graphs-btn" type="flowQuota" sceneCode={sceneCode}/>
        </div>
        {userQuotaData && <div className="border mt_20">
          <p>用户指标数据</p>
          <GraphWrapper key={12} className="overall-effect-graph-wrapper" config={overallEffectLine(userQuotaData, userQuotaData.isRate)} height={350}/>
          <DownloadDialog key={2} className="traffic-bucket-content-graphs-btn" type="userQuota" sceneCode={sceneCode}/>
        </div>}
      </div>);
    }
}
